export default "__VITE_ASSET__DUbq9HCt__"